import { useQuery } from '@tanstack/react-query';
import { supabase } from '../utils/supabaseClient';
import { queryKeys } from '../utils/queryKeys';

const fetchCategories = async () => {
  const { data, error } = await supabase
    .from("categories")
    .select("*")
    .order('id', { ascending: true });

  if (error) throw error;

  // Asegurarse que "All" (id: 9) esté al principio
  return data.sort((a, b) => {
    if (a.id === 9) return -1;
    if (b.id === 9) return 1;
    return a.name.localeCompare(b.name);
  });
};

export function useSecondaryCategories() {
  const { data: categories = [], isLoading, error } = useQuery({
    queryKey: queryKeys.categories.all,
    queryFn: fetchCategories,
    staleTime: 1000 * 60 * 60, // 1 hora - las categorías cambian con poca frecuencia
    cacheTime: 1000 * 60 * 60 * 24, // 24 horas
  });

  const getCategorySlug = (categoryName) => {
    if (!categoryName) return '';
    return categoryName.toLowerCase().replace(/\s+/g, '_');
  };

  const getCategoryIdFromSlug = (slug) => {
    if (slug === 'all') return 9;
    const category = categories.find(
      cat => getCategorySlug(cat.name) === slug
    );
    return category ? category.id : 9;
  };

  const getCategoryNameById = (id) => {
    const category = categories.find(cat => cat.id === id);
    return category ? category.name : 'All';
  };

  const categoryExists = (slug) => {
    if (slug === 'all') return true;
    return categories.some(cat => getCategorySlug(cat.name) === slug);
  };

  return {
    categories,
    isLoading,
    error,
    getCategorySlug,
    getCategoryIdFromSlug,
    getCategoryNameById,
    categoryExists
  };
}